var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormTablePlaInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.16672C4.78334 2.16672 2.1665 4.78352 2.1665 7.99997C2.1665 11.2166 4.78334 13.8334 7.99984 13.8334C11.2163 13.8334 13.8332 11.2166 13.8332 7.99997C13.8332 4.78352 11.2163 2.16672 7.99984 2.16672ZM7.99976 15.3334C3.95624 15.3334 0.666504 12.0437 0.666504 7.99997C0.666504 3.95645 3.95624 0.666718 7.99976 0.666718C12.0433 0.666718 15.333 3.95645 15.333 7.99997C15.333 12.0437 12.0433 15.3334 7.99976 15.3334Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.24805,
    y: 6.26083,
    width: 1.31626,
    height: 6.25226,
    rx: 0.658132,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90614 5.40207C8.45155 5.40207 8.89334 4.9601 8.89334 4.41499C8.89334 3.86964 8.45155 3.42767 7.90614 3.42767C7.36073 3.42767 6.91895 3.86964 6.91895 4.41499C6.91895 4.9601 7.36073 5.40207 7.90614 5.40207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormTablePlaInfo);
export default __webpack_public_path__ + "static/media/formTablePlaInfo.f45eaa3b5f0d569e8062ac76d4763057.svg";
export { ForwardRef as ReactComponent };